/*
 * Module for the DROP Statements job criteria page
 */
rs.module("content/jobs/criteria/dropstatements",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(
            jsSelectors,
            deliveryMethodOptions,
            deliveryMethodOptionValues,
            printers,
            preferredPrinter,
            outputTypeOptions,
            statementPeriodOptionsValues,
            isBatchTypeIndividual,
            individualDefaultPreference,
            codeValues) {

            var criteria = $.js(jsSelectors.criteria);

            var dropPlanSelect = criteria.js(jsSelectors.dropPlanSelect, { required: false });
            var dropPlanNameHidden = criteria.js(jsSelectors.dropPlanNameHidden);
            var statementPeriodSelect = criteria.js(jsSelectors.statementPeriodSelect);
            var outputTypeSelect = criteria.js(jsSelectors.outputTypeSelect);
            var skipReviewCheckBox = criteria.js(jsSelectors.skipReviewCheckBox);
            var deliveryMethodSelect = criteria.js(jsSelectors.deliveryMethodSelect);
            var printersSelect = criteria.js(jsSelectors.printersSelect);
            var emailAddressInput = criteria.js(jsSelectors.emailAddressInput);
            var emailAddressHiddenInput = criteria.js(jsSelectors.emailAddressHiddenInput, { required: false });
            var ccEmailAddressInput = criteria.js(jsSelectors.ccEmailAddressInput);
            var emailSubjectInput = criteria.js(jsSelectors.emailSubjectInput);
            var emailTextInput = criteria.js(jsSelectors.emailTextInput);
            var reviewCommentTextArea = criteria.js(jsSelectors.reviewCommentTextArea, { required: false });

            // Get Select Helper for Select Lists since we're updating their options and properties
            var deliveryMethodSelectHelper = selectHelper.getHelper(deliveryMethodSelect);
            var printersSelectHelper = selectHelper.getHelper(printersSelect);

            // On Drop Plan value change, store text in Hidden Field (dropPlanName) needed for job criteria
            dropPlanSelect.change(function () {
                dropPlanNameHidden.val(dropPlanSelect.find(":selected").text());
            });

            // Register statementPeriodSelect change event to hide/show appropriate fields
            statementPeriodSelect.change(hideShowStatementPeriodFields);

            // Register outputTypeSelect change event to hide/show appropriate fields 
            outputTypeSelect.change(onOutputTypeChanged);

            // Register skipReviewCheckBox change event to enable/disable appropriate fields
            skipReviewCheckBox.change(onSkipReviewChanged);

            // Register deliveryMethodSelect change event to enable/disable appropriate fields
            deliveryMethodSelect.change(onDeliveryMethodChanged);

            // On page initialize, store DROP Plan Name in Hidden Field based on current value
            dropPlanNameHidden.val(dropPlanSelect.find(":selected").text());

            // On page initialize, hide/show Statement Period fields/rows
            $(hideShowStatementPeriodFields);

            // Hide or show Statement Period Fields
            function hideShowStatementPeriodFields() {

                // Hide All
                visibility.hide(criteria.js(jsSelectors.statementYearFilterRow));
                visibility.hide(criteria.js(jsSelectors.quarterlyFilterRow));
                visibility.hide(criteria.js(jsSelectors.monthlyFilterRow));
                visibility.hide(criteria.js(jsSelectors.dateRangeFilterRow));

                switch (statementPeriodSelect.val()) {
                    case statementPeriodOptionsValues.annual:
                        visibility.show(criteria.js(jsSelectors.statementYearFilterRow));
                        break;

                    case statementPeriodOptionsValues.monthly:
                        visibility.show(criteria.js(jsSelectors.statementYearFilterRow));
                        visibility.show(criteria.js(jsSelectors.monthlyFilterRow));
                        break;

                    case statementPeriodOptionsValues.quarterly:
                        visibility.show(criteria.js(jsSelectors.statementYearFilterRow))
                        visibility.show(criteria.js(jsSelectors.quarterlyFilterRow));
                        break;

                    case statementPeriodOptionsValues.userDefined:
                        visibility.show(criteria.js(jsSelectors.dateRangeFilterRow));
                        break;

                    default:
                        break;
                }
            }

            // Output Type has changed
            function onOutputTypeChanged() {

                switch (outputTypeSelect.val()) {
                    case outputTypeOptions.correspondence:
                        visibility.show(skipReviewCheckBox.closest(criteria.js(jsSelectors.outputFilterRow, { multiple: true })));
                        visibility.show(deliveryMethodSelect.closest(criteria.js(jsSelectors.outputFilterRow, { multiple: true })));
                        visibility.show(printersSelect.closest(criteria.js(jsSelectors.outputFilterRow, { multiple: true })));
                        break;

                    case outputTypeOptions.export:
                        visibility.hide(skipReviewCheckBox.closest(criteria.js(jsSelectors.outputFilterRow, { multiple: true })));
                        visibility.hide(deliveryMethodSelect.closest(criteria.js(jsSelectors.outputFilterRow, { multiple: true })));
						visibility.hide(printersSelect.closest(criteria.js(jsSelectors.outputFilterRow, { multiple: true })));
                        break;

                    default:
                        break;
                }
            }

            // Skip Review has changed
            function onSkipReviewChanged() {

                if (skipReviewCheckBox.is(":checked")) {

                    //disable and clear review comment text area
                    reviewCommentTextArea.val("").prop("disabled", true);

                    //enable and re-populate delivery method select
                    deliveryMethodSelectHelper.setDisabled(false);
                    deliveryMethodSelectHelper.replaceOptions(deliveryMethodOptions);

                    //fire delivery method change event
                    onDeliveryMethodChanged();
                }
                else {

                    //enable review comment text area
                    reviewCommentTextArea.prop("disabled", false);

                    //disable and clear delivery method select
                    deliveryMethodSelectHelper.clearOptions();
                    deliveryMethodSelectHelper.setDisabled(true);

                    //hide and clear email inputs
                    visibility.hide(criteria.js(jsSelectors.emailFilterRow));
                    emailAddressInput.val("").clearErrors();
                    ccEmailAddressInput.val("").clearErrors();
                    emailSubjectInput.val("").clearErrors();
                    emailTextInput.val("").clearErrors();

                    //show, disable and clear printer select
                    visibility.show(criteria.js(jsSelectors.printerFilterRow));
                    printersSelectHelper.clearOptions();
                    printersSelectHelper.setDisabled(true);
                }
            }

            // Delivery method has changed
            function onDeliveryMethodChanged() {

                var selectedDeliveryMethod = deliveryMethodSelect.val();

                // If batch type is individual, and the selected delivery method is email or the participant has a default preference of email
                if (isBatchTypeIndividual &&
                    (selectedDeliveryMethod == deliveryMethodOptionValues.email ||
                    (selectedDeliveryMethod == deliveryMethodOptionValues.defaultPreference && individualDefaultPreference.distributionMethod == codeValues.email))) {

                    // hide printer field
                    visibility.setVisible(criteria.js(jsSelectors.printerFilterRow), false);

                    // show email fields (prepopulate from default preference)
                    visibility.setVisible(criteria.js(jsSelectors.emailFilterRow), true);
                    emailAddressInput.val(individualDefaultPreference.emailAddress);
                    emailAddressInput.prop("disabled", selectedDeliveryMethod == deliveryMethodOptionValues.defaultPreference);
                    emailAddressHiddenInput.val(individualDefaultPreference.emailAddress);
                }
                // Otherwise, assume printing
                else {

                    // hide email fields
                    visibility.setVisible(criteria.js(jsSelectors.emailFilterRow), false);

                    // enable, show and re-populate printer select
                    printersSelectHelper.setDisabled(false);
                    printersSelectHelper.replaceOptions(printers);
                    visibility.setVisible(criteria.js(jsSelectors.printerFilterRow), true);

                    // since we have reloaded printers, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printersSelectHelper.setValue(preferredPrinter);
                    }
                }
            }
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);